module.exports = __webpack_public_path__ + "assets/8d0c55dccd18b27e60ea51842dcf0a24.mp3";